var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    preserveAspectRatio: "xMidYMid",
    viewBox: "-38.39985 -104.22675 332.7987 625.3605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M125.166 285.168l2.795 2.79 127.962-75.638L127.961 0l-2.795 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M127.962 287.959V0L0 212.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "M126.386 412.306l1.575 4.6L256 236.587l-128.038 75.6-1.575 1.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M0 236.585l127.962 180.32v-104.72z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M127.961 154.159v133.799l127.96-75.637z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M127.96 154.159L0 212.32l127.96 75.637z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.5ed786b026a141819383dd6e667c42d3.svg";
export { ForwardRef as ReactComponent };